import React, { useEffect } from 'react';
import ProgressBar from 'src/view/shared/ProgressBar';
import Spin from 'antd/es/spin';

const LoadingComponent = () => {
  useEffect(() => {
    ProgressBar.start();
    return () => {
      ProgressBar.done();
    };
  }, []);

  return <Spin size='large' fullscreen />;
};

export default LoadingComponent;
